// Breadcrumb
var pagetitle = $('[data-pagetitle]').data('pagetitle');
var childlink = '<span aria-hidden="true">›</span><span>' + pagetitle + '</span>';
if($('nav.breadcrumb span').length == 0)
{
 $('nav.breadcrumb').append(childlink);
}


// SCROLL TO TOP SCRIPT
  var scrollToTopBtn = document.querySelector(".scrollToTopBtn")
  var rootElement = document.documentElement
  
  function handleScroll() {
    // Do something on scroll - 0.15 is the percentage the page has to scroll before the button appears
    // This can be changed - experiment
    var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight
    if ((rootElement.scrollTop / scrollTotal ) > 0.15) {
      // Show button
      scrollToTopBtn.classList.add("showBtn")
    } else {
      // Hide button
      scrollToTopBtn.classList.remove("showBtn")
    }
  }
  
  function scrollToTop() {
    // Scroll to top logic
    rootElement.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }
  scrollToTopBtn.addEventListener("click", scrollToTop)
  document.addEventListener("scroll", handleScroll)

// search highlight
$('.header_search_form .search__input').on('input',function(e) {
	setTimeout(function() {
	   $(".header_search_form").find(".highlight").removeClass("highlight");
		var searchword = $(".header_search_form .search__input").val();
		var custfilter = new RegExp(searchword, "ig");
		var repstr = "<span class='highlight'>" + searchword + "</span>";
		if (searchword != "") {
			$('.header_search_form .predictive-search__results-list h3').each(function() {
				var newHtml = $(this).html().replace(custfilter, repstr);
				$(this).html(newHtml);
			})
		}
	}, 1500);	
});  
  

$(document).ready(function(){

    // social share
    $(".share-menu-toggle").click(function(){
      $(".share-menu").toggleClass("open");
    });

  
  
    // list grid view
  $(document).on("click", '.list_n_grid span img', function(event) {
      $(this).closest('span').siblings().removeClass("active");
      $(this).closest('span').addClass("active");   
  });      
  $(document).on("click", '.list_view,.list_view img', function(event) {
      $("#product-grid").addClass("list_view");  
  });     
  $(document).on("click", '.grid_view,.grid_view img', function(event) {
      $("#product-grid").removeClass("list_view"); 	
  });	 

  
    
  //tabs
  $('.tab-content').hide();
  $('.toggle_click').click(function() {
    var checkActiveClass = $(this).hasClass('active')
        $('.toggle_click').removeClass('active');
        $('.toggle_content').removeClass('active');
    if(checkActiveClass){
        $('.toggle_click').removeClass('active');
        $('.toggle_content').removeClass('active');
    }else{
        var activeTabContent = $(this).attr('data-id');
       $(this).addClass('active');
       $('#toggle_content_'+activeTabContent).addClass('active');
    } 
  });
  setTimeout(function () {
      $('.childlink.active').closest('.toggle_content').siblings('.tab_cat').trigger('click');
  }, 500);

// doc ready ends 
});


// image zoom
$(document).ready(function(){
  $('.carousel-main .carousel-cell').each(function(){
    var originalImagePath = $(this).find('img').data('original-image');
    $(this).zoom({
      url: originalImagePath,
      magnify: 1
    });
  });
});   

// additional option
$('.primary_option a.active').click(function (e) {
    e.preventDefault();
});  

// update sku product page
  $("variant-radios fieldset.js.product-form__input input[type=radio]+label").click(function (e) {
      $('.product_bottom_meta .data_normal_text.sku').html('');
      $('.pop-up-content-wrap.japa .item_details').html('');
          setTimeout(function () {
            $.ajax({
                url: window.location.href,
                type: "GET",
                success: function(data) {
                    var pdata = $(data).find('.product_bottom_meta .data_normal_text.sku').html();
                    var formdata = $(data).find('.pop-up-content-wrap.japa .item_details').html();
                    $('.product_bottom_meta .data_normal_text.sku').html(pdata);
                    $('.pop-up-content-wrap.japa .item_details').html(formdata);
                }
            });
          }, 10);
  });

// ask a question popup
$(".product-btn-inquery-buttons a.product-btn-inquery.quote").click(function (e) {
  e.preventDefault();
  $(".custom-model-main").addClass('model-open');
});
$(".close-btn, .bg-overlay").click(function(){
  $(".custom-model-main").removeClass('model-open');
});